import { trainerService } from './trainerService';

export interface TrainerDashboardStats {
    totalClients: number;
    activeClients: number;
    trainerCode: string;
    trainerName: string;
    isLoading: boolean;
    error: string | null;
}

export class TrainerDashboardService {
    async getDashboardStats(): Promise<TrainerDashboardStats> {
        try {
            const stats: TrainerDashboardStats = {
                totalClients: 0,
                activeClients: 0,
                trainerCode: '',
                trainerName: '',
                isLoading: false,
                error: null,
            };

            // Get trainer profile
            try {
                const profileResponse = await trainerService.getMyProfile();
                if (profileResponse.profile) {
                    stats.trainerCode = profileResponse.profile.trainerCode || '';
                    stats.trainerName = profileResponse.profile.name || '';
                }
            } catch (error) {
                console.error('Error fetching trainer profile:', error);
            }

            // Get client statistics
            try {
                const clientsResponse = await trainerService.getTrainerClients({
                    page: 1,
                    limit: 1000, // Get all clients for counting
                });

                stats.totalClients = clientsResponse.total_count;
                stats.activeClients = clientsResponse.clients.filter(client => client.is_active).length;
            } catch (error) {
                console.error('Error fetching client stats:', error);
            }

            return stats;
        } catch (error: any) {
            throw new Error(error.message || 'Failed to fetch dashboard statistics');
        }
    }
}

export const trainerDashboardService = new TrainerDashboardService();
